import {useDataTracking} from '#imports';
import {useLandingTrackingSource} from '~/common/composables';

export function useProjectListTracking() {
    const {track} = useDataTracking();
    const {getLandingTrackingSource} = useLandingTrackingSource();

    function trackProjectListViewed() {
        track('client_project_list_viewed', {
            source: getLandingTrackingSource(),
        });
    }

    return {trackProjectListViewed};
}
